import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Grid, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { useFetchMediaGroupTypeList } from 'src/network/media-group';
import { generateSelectMenuItems } from 'src/utils';
import { GeneralSelectMenu } from 'src/components/general';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

export default function MediaPlaylistTableToolbar({ onChangePage, setFilterItems }) {
  const [mediaPlaylistFilters, setMediaPlaylistFilters] = useLocalStorage('mediaPlaylistFilters');

  const defaultValues = {
    ...mediaPlaylistFilters,
  };

  const methods = useForm({
    defaultValues,
  });

  const [mediaGroupTypeList, setMediaGroupTypeList] = useState([]);
  const [selectedMediaGroupType, setSelectedMediaGroupType] = useState('');

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values) => {
    const PAYLOAD = {
      ID: -1,
      Title: values?.Title || '',
      GroupID: selectedMediaGroupType,
    };

    setMediaPlaylistFilters(PAYLOAD);

    onChangePage(null, 0);
    setFilterItems(PAYLOAD);
  };

  const { data: mediaGroupTypeResult } = useFetchMediaGroupTypeList();

  useEffect(() => {
    if (mediaGroupTypeResult) {
      const mediaGroupTypes = generateSelectMenuItems(mediaGroupTypeResult?.data?.items, 'MediaGroupTypeLable', 'MediaGroupTypeID');
      setMediaGroupTypeList(mediaGroupTypes);
      setSelectedMediaGroupType(mediaPlaylistFilters?.GroupID || mediaGroupTypes?.[0]?.id);
    }
  }, [mediaGroupTypeResult]);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'grid',
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' },
            }}
          >
            <RHFTextField name="Title" type="text" label="نام محتوا" />

            <GeneralSelectMenu
              label="نوع محتوا"
              name="MediaGroupMediaGroupTypeID"
              options={mediaGroupTypeList}
              value={selectedMediaGroupType}
              onChangeValue={setSelectedMediaGroupType}
            />

            <LoadingButton size="medium" type="submit" variant="contained" loading={isSubmitting} sx={{ height: '55px' }}>
              جستجو
            </LoadingButton>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
